<template>
  <textarea :data-vv-as="field.description.replace(/\./g, '')"
            :id="field.name"
            :name="field.name"
            :readonly="locked"
            class="form-control"
            v-validate="validators"
            :minlength="field.minSize"
            :maxlength="field.maxSize"
            rows="6"
            :value="value"
            @input="input"
  />
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['input'],

  setup(props, { emit }) {
    const input = (e) => {
      const v = e.target.value;
      if (props.field.maxSize > 0 && String(v).length > props.field.maxSize){
        emit('input', props.value)
      } else {
        emit('input', v)
      }
    }

    const validators = computed(() => {
      return {
        required: !props.field.hide && props.required,
        max: props.field.maxSize > 0 ? props.field.maxSize : false,
        min: props.field.minSize > 0 ? props.field.minSize : false
      }
    })

    return {
      validators,
      input,
    }
  }
}
</script>



// WEBPACK FOOTER //
// TextareaRender.vue?3e53f0bf